import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html'
})
export class EmptyStateComponent {
  /** Nome do ícone Lucide a ser exibido (ex: 'calendar-x', 'book-open') */
  @Input() icone?: string;

  /** Caminho de imagem PNG/SVG caso prefira ilustração ao ícone */
  @Input() imagem?: string;

  /** Título principal (opcional para permitir empty states apenas com ng-content) */
  @Input() titulo?: string;

  /** Parágrafo de descrição opcional */
  @Input() descricao?: string;

  /** Tema de cor do círculo de fundo do ícone */
  @Input() tema: 'slate' | 'yellow' | 'red' = 'slate';

  get bgClass(): string {
    switch (this.tema) {
      case 'yellow': return 'bg-yellow-100 dark:bg-yellow-900/30';
      case 'red':    return 'bg-red-50 dark:bg-red-900/30';
      default:       return 'bg-slate-100 dark:bg-slate-800/60';
    }
  }

  get iconClass(): string {
    switch (this.tema) {
      case 'yellow': return 'text-yellow-600 dark:text-yellow-500';
      case 'red':    return 'text-red-500 dark:text-red-400';
      default:       return 'text-slate-400 dark:text-slate-500';
    }
  }
}

